import { HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { HoverCard } from "@radix-ui/react-hover-card";
import { AlertTriangle } from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";
import QuoteList from "@/components/sliders/quotelist";

interface Props {
  menuName: string;
  Icon: {
    menuIcon: React.ElementType;
    iconSize: number;
  };
  isOpen: boolean;
  navigateTo?: string;
  openDialog?:boolean;
  hooverCardName?: string;
  userFirstName?: string;
}

export default function SlideMenuGenerator({
  menuName,
  Icon,
  isOpen,
  navigateTo,
  hooverCardName,
  userFirstName,
  openDialog
}: Props) {

 
  return (
    <TooltipProvider>
      <Tooltip key={menuName} >
        <TooltipTrigger asChild>
          <div className={`flex ${isOpen ? "pl-2 border-l-2 border-transparent transition-opacity duration-300 hover:border-harvey-red" : "pb-2 border-b-2 border-transparent transition-opacity duration-300 hover:border-harvey-red"}`}>
              <Link
                to={navigateTo!}
                className={`flex w-full ${isOpen && "float-left"} `}
              >
                {React.createElement(Icon.menuIcon, { size: Icon.iconSize })}
                <span className={`ml-2 ${!isOpen && "hidden"} origin-left duration-200`}>
                  {menuName}
                </span>
              </Link>

            {isOpen && hooverCardName === "quotations" ? (
                <HoverCard key={menuName}>
                  <HoverCardTrigger>
                    <QuoteList />
                  </HoverCardTrigger>
                  <HoverCardContent className="w-80 text-left bg-harvey-black text-gray-300 z-50">
                    <div className="flex justify-between space-x-4 z-50">
                      <AlertTriangle size={64} />
                      <div className="cap z-50">
                        {userFirstName},<br />
                        You have Active Quotations to Approve, click here to
                        view.
                      </div>
                    </div>
                  </HoverCardContent>
                </HoverCard>
            ):(<> </>)}
          </div>
        </TooltipTrigger>
        {!isOpen && (
          <TooltipContent className="bg-harvey-black z-50" sideOffset={2}>
            <p className="bg-harvey-black z-50">{menuName}</p>
          </TooltipContent>
        )}
      </Tooltip>
    </TooltipProvider>
  );
}
